// extracted by mini-css-extract-plugin
export default {"wrapper":"notAuthorized_wrapper__J1kBt","message-wrapper":"notAuthorized_message-wrapper__u1GaB","icon":"notAuthorized_icon__qNh9s","message":"notAuthorized_message__qVUtr"};